// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a6b9a902","453":"55b83d62","455":"04e8227e"}[chunkId] + ".chunk.js";
};